module.exports = __webpack_public_path__ + "bbb53eecf18e8e137397c7c007ee53f6.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/brand_ambassadors/save_gold_macbook.png
// module id = 570
// module chunks = 0